import React, { useContext } from 'react';
import { question_circle, unimel_icon } from '../assets';
import { AuthContext } from '../context/AuthContext';

const Header = () => {
const { user, course } = useContext(AuthContext);


  return (
    <header className="top-0 w-full flex items-center justify-between p-4 bg-white font-Inter border-b shadow-md z-10">
      {/* Left Section */}
      <div className="flex items-center">
        <img
          src={unimel_icon}
          alt="Logo"
          className="h-12 mr-4"
        />
        <p className="text-[#D69D0B] font-medium text-lg">Tutor IA</p>
      </div>

      {/* Right Section */}
      <div className="flex items-center space-x-6">
        <div className="text-[#D69D0B] text-lg flex items-center">
          {/* Mostrar nombre del curso si existe */}
          {course?.["NOMBRELARGOCURSO"] && (
           <>
              <span className="mr-2">{course["NOMBRELARGOCURSO"]}</span>
              <span className="mx-2 text-gray-400">-----</span>
            </>
         )}
          {/* Mostrar nombre del alumno o 'ESTUDIANTE' */}
          {user ? user['Nombre Alumno'] : 'ESTUDIANTE'}
        </div>
        <div className="text-[#767676] flex items-center">          
          <img src={question_circle} alt="Help" className="h-6" />
       </div>        
      </div>

    </header>
  );
};

export default Header;
